import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TechCommunitiesModalComponent } from 'src/app/component/tech-communities-modal/tech-communities-modal.component';

@Component({
  selector: 'app-extreme-lab',
  standalone: false,
  templateUrl: './extreme-lab.component.html',
  styleUrls: ['./extreme-lab.component.scss']
})
export class ExtremeLabComponent {
  public simpleDialog!: MatDialogRef<TechCommunitiesModalComponent>;
  public dialogDataConfig: any = {};
  public access: boolean = true;

  constructor(private dialogModel: MatDialog, private router: Router) { }

  ngOnInit() {

      window.open('https://instructoraccess.learnondemand.net','_blank');
    this.router.navigate(['/home']);

    // this.dialogDataConfig = {
    //   title: 'Extreme Labs',
    //   accessto: "Extreme Labs"
    // }

    // // disableClose: true
    // this.simpleDialog = this.dialogModel.open(
    //   TechCommunitiesModalComponent, { data: this.dialogDataConfig },
    // );
  }
}
